import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import {
  Column,
  device,
  TrailRow,
  typography,
  mobileGutterMargin,
  useMedia,
} from '@landsbankinn/ui';
import React from 'react';
import { animated } from 'react-spring';
import { Img } from '../img/Img';

interface IProps {
  title: string;
  copy: React.ReactNode;
  action?: React.ReactNode;
  image?: Prismic.Image;
}

const Host = styled(animated.div)`
  ${mobileGutterMargin}
  margin: ${(props) => `0 -${props.theme.containerGutter}px`};

  > div > div:first-child {
    z-index: 2;
  }

  @media ${device.tablet} {
    margin: 0;
  }
`;

const Background = styled.div`
  position: relative;
  z-index: 1;
  background-image: ${(props) => props.theme.gradients.primary};

  padding: ${(props) => `100px ${props.theme.containerGutter}px`};

  @media ${device.mobile} {
    padding: ${(props) => `100px ${props.theme.breakpoints.sm.gutter}px`};
  }

  @media ${device.tablet} {
    padding: 100px;
    margin: 0;
  }

  @media ${device.desktop} {
    padding: 100px 72px 60px 72px;
  }
`;

const H2 = styled.h2`
  ${typography.h2}
  margin-bottom: 1.5em;
  color: ${(props) => props.theme.colors.background};
`;

const Copy = styled.div`
  margin-bottom: 4em;
  color: ${(props) => props.theme.colors.background};

  @media ${device.tablet} {
    margin-bottom: 60px;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  flex-flow: column wrap;

  a {
    width: initial;
    outline-offset: -0.4rem;
  }

  @media ${device.tablet} {
    flex-flow: row wrap;
    justify-content: flex-start;
  }
`;

const ImageWrap = styled.div`
  /* margin: 0 -20px; */

  @media ${device.tablet} {
    margin: 0;
  }

  @media ${device.desktop} {
    margin-top: 120px;
    margin-left: -200px;
  }
`;

export const BecomeACustomer = ({ title, copy, action, image }: IProps) => {
  const isMobile = useMedia('sm');
  return (
    <Host>
      <TrailRow gutter={isMobile ? 0 : undefined}>
        <Column
          style={{ zIndex: 2 }}
          md={{ width: 12 / 12 }}
          lg={{ width: 6 / 12 }}
          sm={{ gutter: 0 }}
        >
          <Background>
            <H2>{title}</H2>
            <Copy>{copy}</Copy>
            {action && <ButtonWrap>{action}</ButtonWrap>}
          </Background>
        </Column>
        <Column
          md={{ width: 12 / 12 }}
          lg={{ width: 6 / 12 }}
          sm={{ gutter: 0 }}
        >
          <ImageWrap>
            <Img src={image} ar="ar_4_3" percentage={0.7} />
          </ImageWrap>
        </Column>
      </TrailRow>
    </Host>
  );
};
